import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type P2PRelayInfo = {
  peerId: string;
  multiaddrs: string[];
};

export const p2pRelayInfoQueryAtom = createQueryAtomFactory(
  'settings.p2pRelayInfo',
  () => ({
    iotP2PRelayInfo: {
      peerId: true,
      multiaddrs: true,
    },
  }),
  {
    select: (data): P2PRelayInfo => ({
      peerId: data?.iotP2PRelayInfo?.peerId ?? '',
      multiaddrs: (data?.iotP2PRelayInfo?.multiaddrs as string[]) ?? [],
    }),
  },
);

export const $p2pRelayInfo = p2pRelayInfoQueryAtom();
